import ListOption from "../EditAutomations/ListOption";
import { RuleProvider, useRule } from "./RuleReducer";
import classes from '../CreateRule/SelectOutputs.module.css'
import { useEffect, useState } from "react";
import ProgressBar from "./ProgressBar";

const ChooseTime = ({navigate, createRule}) => {

    const { state, dispatch } = useRule(RuleProvider);
    const [time, setTime] = useState(state.inputRule)
    const [progress, setProgress] = useState(100)

    const SetTitle = () => {
        let title;
        switch (state.inputType){
            case 3: 
                title = "arm"
                break;
            case 4: 
                title = "disarm"
                break;
        }

        return title;
    }

    const HandleText = () => {
        let inputType;
        let inputRule;
        switch (state.inputType) {
            case 0:
                inputType = `${state.pinStatusOn}`;
                break;
            case 1: 
                inputType = `${state.pinStatusOn} or ${state.pinStatusOff}`;
                break;
            case 2:
                inputType = `${state.pinStatusOff}`;
                break;
            case 3:
                inputType = `${state.pinStatusOn}`;
                inputRule = "will temporarily arm"
                break;
            case 4:
                inputType = `${state.pinStatusOn}`;
                inputRule = "will temporarily disarm"
                break;
            default:
                inputType = "unknown";
                break;
        }

        
        switch (state.inputRule) {
            case 0:
                inputRule = `will match ${state.pinName} state`;
                break;
            case 1: 
                inputRule = `will oppose ${state.pinName} state`;
                break;
            case 2:
                inputRule = `will toggle`;
                break;
        }
        return `When ${state.pinName} is ${inputType}, ${state.selectedPinsToAffect.map(pin => pin.pinName).join(", ")} ${inputRule} for ${time} minutes`;
    }

    const HandleNavigate = (direction) => {

        if (direction === "back"){
            navigate(3)
        }
        console.log(time)
        dispatch({type: "SET_INPUT_RULE", payload: (time * 60000)})
        createRule(time * 60000, state.selectedPinsToAffect)
        
    }

    return (
       <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "20px" }}>
        <ProgressBar progress={progress} />
        <div style={{display: "flex", flexDirection:"row", alignItems:"center", justifyContent:"space-between", gap: "20px"}}>
                <button className={classes.nextButton} onClick={() => HandleNavigate("back")} >{"<"}</button>
                <ListOption optionText={HandleText()} propsClassName={classes.infoBox} />
                <button className={classes.nextButton} onClick={() => HandleNavigate("next")} >{">"}</button>
            </div>
            
            <h3 style={{ color:"#6e6e6e"}}>How many minutes should they temporarily {SetTitle()} for</h3>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", alignContent:"center", gap: "10px" }}>
                <input
                    type="text"
                    className={`${classes.inputField}`}
                    value={time}
                    onChange={(e) => setTime(e.target.value)}
                    required
                />
            </div>
           
        </div>
    )
}

export default ChooseTime;